import React from 'react'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'

// One row per recorded change to public course data, newest first.
//
// The diff is the whole point: "user X edited course Y" says nothing about whether it was
// a correction or vandalism, and only `before -> after` does. A row the server could not
// recover a previous state for is shown with its revert disabled rather than hidden —
// knowing an edit happened still matters, even when this page cannot undo it.
const formatTime = (ms) => (ms ? new Date(ms).toLocaleString() : '')

const truncate = (value) => {
  if (value == null) return <em className="text-muted">none</em>
  if (value === '') return <em className="text-muted">empty</em>
  return value.length > 60 ? `${value.slice(0, 60)}…` : value
}

export default function EditsTable({ edits, onRevert, onFilterAccount, working }) {
  if (edits.length === 0) {
    return <p className="text-muted">No edits to public course data in this window.</p>
  }

  return (
    <Table size="sm" responsive hover>
      <thead>
        <tr>
          <th>When</th>
          <th>Who</th>
          <th>Course</th>
          <th>What changed</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {edits.map((edit) => (
          <tr key={edit.auditId}>
            <td className="text-nowrap">{formatTime(edit.created)}</td>
            <td>
              <Button
                variant="link"
                size="sm"
                className="p-0"
                onClick={() => onFilterAccount(edit.accountId)}
                disabled={!edit.accountId}
              >
                {edit.email || `account ${edit.accountId ?? '?'}`}
              </Button>
            </td>
            <td>
              {edit.courseName || `course ${edit.courseId}`}{' '}
              <Badge bg="secondary">{edit.entityType.toLowerCase()}</Badge>
            </td>
            <td>
              {edit.changes.length === 0 && <span className="text-muted">no field differences</span>}
              {edit.changes.map((change) => (
                <div key={change.field} className="small">
                  <strong>{change.field}</strong>: {truncate(change.before)} →{' '}
                  {truncate(change.after)}
                </div>
              ))}
            </td>
            <td className="text-nowrap">
              <Button
                size="sm"
                variant="outline-danger"
                disabled={!edit.revertable || working}
                onClick={() => onRevert(edit.auditId)}
                title={edit.revertable ? 'Restore the recorded previous state' : 'Nothing recorded to restore'}
              >
                Revert
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
